import styled from "styled-components";

export const NavBar = styled.nav`
  overflow: hidden;
  position: relative;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 20px 20px 0 0;
  box-shadow: ${(props) => props.theme.shadows.nav};
  z-index: 2;
`;

export const NavList = styled.ul`
  display: flex;
  width: 100vw;
  height: 100px;
  align-items: center;
  justify-content: center;

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    height: 65px;
  }
`;
